const PUBLIC_PATHS = new Set(['/', '/terms', '/register']);

/** Routes available without an in-game session (unauthorized landing zone). */
export function isPublicPath(pathname: string): boolean {
	if (PUBLIC_PATHS.has(pathname)) {
		return true;
	}
	if (/^\/verify\/[^/]+\/[^/]+$/.test(pathname)) {
		return true;
	}
	if (/^\/reset\/[^/]+\/[^/]+$/.test(pathname)) {
		return true;
	}
	return false;
}
